import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, computed, input, output, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrencyPipe } from '@shared/pipes/currency.pipe';
import { PercentagePipe } from '@shared/pipes/percentage.pipe';
import { HeaderPromoDetail } from './header-promo-detail';

@Component({
  selector: 'app-header-promo-detail',
  standalone: true,
  imports: [NgTemplateOutlet, NgClass, CurrencyPipe, PercentagePipe, TranslatePipe],
  templateUrl: './header-promo-detail.component.html',
  styleUrl: './header-promo-detail.component.scss'
})
export class HeaderPromoDetailComponent {
  data = input<HeaderPromoDetail>();
  isClose = output<void>();

  // overused localstorage, promotype dapet dari json?
  isAffiliateProgram = signal<boolean>(localStorage.getItem('promoType') === 'affiliate');
  isPoinPackage = signal<boolean>(localStorage.getItem('promoType') === 'poin');

  contextDataPromo = computed(() => {
    return {
      price: this.data()?.price,
      validity: this.data()?.validity
    };
  });

  contextDataPoin = computed(() => {
    return {
      poin: this.data()?.poin
    };
  });

  onClickClose() {
    this.isClose.emit();
  }
}
